export enum InactivityReminder {
	HALF = 'half',
	ONE = 'one',
	THREE = 'three',
	SIX = 'six',
	NEVER = 'never'
}
